import type { FC } from 'react';
import { AICard } from './AiCard/AiCard';
import { useAltDealStructureLink } from './hooks/useAltDealStructureLink';

interface AiAltDealStructureCardProps {
    message: string;
    onLabelClick?: () => void;
    condensed?: boolean;
}

export const AiAltDealStructureCard: FC<AiAltDealStructureCardProps> = ({ message, onLabelClick, condensed }) => {
    const handleLabelClick = useAltDealStructureLink(onLabelClick);

    return (
        <AICard
            label="Alternative Deal Structures"
            dataTestId="alt-deal-structures"
            message={condensed ? '' : message}
            onHandleLabelClick={handleLabelClick}
            showLogo={!condensed}
        />
    );
};
